export default {
	install (Vue) {
		Vue.prototype.$ErrorsMod = function (methodOptions) {
			
			if (process.env.NODE_ENV === 'development') {
				try {
					console.log('error development', methodOptions)
					console.log('error development array', Array.isArray(methodOptions.data))
				} catch(e) {
					console.log(e)
				}

			}
			
			if (methodOptions === undefined) {
                this.$notify.error({
                    title: 'Произошла ошибка',
                    message: `Обратитесь в техподдержку`,
                    offset: 0
				})
				return true //возвращаем ошибку так как описание отсутствует, скорее всего это ошибка соединения
			} else {
				if (methodOptions.status === 400) {
					if (Array.isArray(methodOptions.data)) {
 						for (let i = 0; i < methodOptions.data.length; i++) {
							setTimeout(() => {
                                this.$notify.error({
                                    title: 'Произошла ошибка',
                                    message: methodOptions.data[i].message,
                                    offset: 0
                                })
							}, 200 * (i + 1))
						}
					} else {
                        this.$notify.error({
                            title: 'Произошла ошибка',
                            message: `Обратитесь в техподдержку`,
                            offset: 0
                        })
					}
				} else if (methodOptions.status === 401) {					
					window.$cookies.remove('time_token_die_adminOrg', '/', process.env.VUE_APP_COOCKIE)
					window.location.replace(process.env.VUE_APP_REDIRECT)
				} else if (methodOptions.status === 403) {
                    this.$notify.error({
                        title: 'Произошла ошибка',
                        message: `Запрещено`,
                        offset: 0
                    })
				} else {
                    this.$notify.error({
                        title: 'Произошла ошибка',
                        message: `Обратитесь в техподдержку`,
                        offset: 0
                    })
				}
				return false
			}
		}
	}
}


